import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import type { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { ELEVATION } from '@openx/components-core/lib/theme/elevation.ts';
import type { JSX, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export type TargetingContainerProps = {
  children: ReactNode;
  dataTest?: string;
  name: string | JSX.Element;
  isRequired?: boolean;
  sx?: SxProps<Theme>;
  hasError?: boolean;
  pendoFeature?: string;
};

export const TargetingContainer = ({
  children,
  dataTest,
  name,
  isRequired,
  sx,
  hasError = false,
  pendoFeature,
}: TargetingContainerProps) => {
  const { t } = useTranslation();

  return (
    <Paper
      data-test={dataTest ?? `targeting-section-${name}`}
      data-has-error={hasError ? 'true' : undefined}
      data-pendo-feature={pendoFeature}
      variant="outlined"
      sx={{
        boxShadow: ELEVATION.elevation0,
        mb: theme => theme.spacing(2),
        mt: theme => theme.spacing(2),
        borderColor: theme => (isRequired ? theme.palette.error.main : theme.palette.divider),
        ...sx,
      }}
    >
      {children}

      {isRequired && (
        <Grid>
          <Typography variant="body2" color="error">
            {t('{name} targeting is required', { name })}
          </Typography>
        </Grid>
      )}
    </Paper>
  );
};
